<template>
	<div :class="!flag==0?'mobile':'pc'">
		<div class="titleInfo">
			<img :src="dataInfoN.titleImg" alt="">
		</div>
		<div class="infoMainBox">
			<div class="imgbox"  :style="{display:'inline-block',float:(infotypeN==1?'left':'right')}">
				<img :src="dataInfoN.infoImg" alt="">
			</div>
			<div class="infobox" :style="{display:'inline-block',float:(infotypeN==1?'left':'right')}">
				<span>{{dataInfoN.info}}</span>
				<div class="moreBtn">了解详情</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'app',
		data() {
			return {
				flag: navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				),
				dataInfoN: this.dataInfo,
				infotypeN: this.infotype
			}
		},
		props: ['dataInfo','infotype'],
		methods: {
			
		},
		mounted() {
		
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.pc{
		width: 100%;
		height: 100%;
		color: #333;
		.titleInfo{
			width: 50%;
			margin: 0 auto;
		}
		.infoMainBox{
			padding:40px 0px;
			margin-bottom:30px;
			font-size: 20px;
			line-height: 34px;
			text-align: justify;
			cursor: pointer;
			.imgbox{
				width: 54%;
				padding:0px 10px;
			}
			.infobox{
				text-indent: 40px;
				height: 280px;
				width: 44%;
				position: relative;
			}
			.moreBtn{
				text-indent: 0px;
				position: absolute;
				bottom: 0px;
				right: 20px;
				border: 2px solid rgb(228,30,40);
				border-radius: 8px;
				padding: 2px 4px;
			}
		}
		.infoMainBox::after{
			content: '';
			display: block;
			line-height: 0;
			clear: both;
		}
	}
	.mobile {
		width: 100%;
		height: 100%;
		color: #333;
		.titleInfo{
			width: 50%;
			margin: 0 auto;
			img{
				width: 100%;
			}
		}
		.infoMainBox{
			width: 100%;
			padding:20px 10px;
			box-sizing: border-box;
			margin-bottom:30px;
			font-size: 18px;
			line-height: 34px;
			text-align: justify;
			padding-bottom: 70px;
			cursor: pointer;
			.imgbox{
				width: 100%;
				img{
					width: 100%;
					margin: 0 auto;
					margin-bottom: 16px;
				}
			}
			.infobox{
				width: 100%;
				text-indent: 40px;
				position: relative;
			}
			.moreBtn{
				text-indent: 0px;
				position: absolute;
				bottom: -40px;
				right: 20px;
				border: 2px solid rgb(228,30,40);
				border-radius: 8px;
				padding: 2px 4px;
			}
		}
		.infoMainBox::after{
			content: '';
			display: block;
			line-height: 0;
			clear: both;
		}

	}

</style>
